function Footer() {
    return (
        <footer>
            <div class='footer-content'>
                Contact us through <a href='https://www.facebook.com/groups/663748787168716/' target='_blank' rel='noopener noreferrer'>Facebook</a> or <a 
                    href='mailto:borealisblades@gmail.com' target='_blank' rel='noopener noreferrer'>Email Us</a>
                <br /><br />
                {/*Website attributions and licensing*/}
                <sub>
                    Content background image "brown ice" by <a href='https://www.deviantart.com/darkwood67/art/brown-ice-136812258'>Darkwood</a>, used under <a href='https://creativecommons.org/licenses/by/3.0/'>CC BY 3.0</a> / Cropped from the original.    
                    <br />
                    Website content available under <a href=' https://creativecommons.org/licenses/by-nc-sa/4.0/'>CC BY-NC-SA</a>
                </sub>
                
            </div>
        </footer>
    );
}

export default Footer;